import React from 'react';
import { Box, Typography } from '@mui/material';
import heroLogo from '../images/lantena_white_herosection.png';
import flagVideo from '../images/flag2.mp4';

const ComingSoon = ({ pageName }) => {
  return (
    <Box
      sx={{
        position: 'relative',
        width: '100%',
        height: '100vh',
        overflow: 'hidden',
      }}
    >
      {/* Background Video */}
      <video
        autoPlay
        loop
        muted
        playsInline
        style={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          zIndex: -2,
        }}
      >
        <source src={flagVideo} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
      
      {/* Overlay to darken the video (using navy color with opacity) */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(10, 35, 59, 0.7)', // #0a233b with 70% opacity
          zIndex: -1,
        }}
      />
      
      {/* Foreground Content */}
      <Box
        sx={{
          position: 'absolute',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
          color: '#fbfbfb', // Updated to off-white
          p: 2,
        }}
      >
        {/* Circular Container for Logo with soft blue border */}
        <Box
          sx={{
            backgroundColor: '#fbfbfb', // Off-white background
            borderRadius: '50%',
            width: { xs: '165px', md: '220px' },
            height: { xs: '165px', md: '220px' },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            mb: 2,
            border: '4px solid #a6d1ea', // Soft blue border
          }}
        >
          <Box
            component="img"
            src={heroLogo}
            alt="Hero Logo"
            sx={{
              width: '90%',
              height: '90%',
              objectFit: 'contain',
            }}
          />
        </Box>
        {/* Page Title */}
        <Typography variant="h1" sx={{ fontWeight: 'bold', mb: 2, color: '#fbfbfb' }}>
          {pageName || 'Coming Soon'}
        </Typography>
        {/* "Coming Soon" Subtitle with accent color */}
        <Typography
          variant="h2"
          sx={{
            fontSize: { xs: '2rem', md: '3rem' },
            textTransform: 'uppercase',
            letterSpacing: 4,
            color: '#a6d1ea', // Soft blue for accent
            textShadow: '1px 1px 3px rgba(0,0,0,0.3)', // Subtle shadow for better readability
          }}
        >
          Coming Soon
        </Typography>
      </Box>
    </Box>
  );
};

export default ComingSoon;
